import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { SiteNav } from "@/components/SiteChrome";

export default function AuthPage() {
  const { user, signIn } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await signIn("/auth/login", form);
      navigate("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen bg-slate-50">
      <SiteNav />
      <div className="flex items-center justify-center px-6 py-20">
        <form onSubmit={submit} className="gl-fade-up w-full max-w-sm space-y-6 rounded-2xl border border-slate-200 bg-white p-8 shadow-sm" data-testid="auth-form">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Pack Studio</p>
            <h1 className="mt-1 text-2xl font-extrabold tracking-tight">Owner sign in</h1>
            <p className="mt-2 text-sm text-slate-500">Only the GlossLink owner loads new Gloss Packs. Students don't need an account.</p>
          </div>
          <div className="space-y-1.5"><Label>Email</Label><Input data-testid="login-email-input" type="email" required value={form.email} onChange={set("email")} /></div>
          <div className="space-y-1.5"><Label>Password</Label><Input data-testid="login-password-input" type="password" required value={form.password} onChange={set("password")} /></div>
          {error && <p data-testid="auth-error" className="rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}
          <Button data-testid="login-submit-button" type="submit" disabled={busy} className="h-11 w-full rounded-lg bg-blue-600 hover:bg-blue-700">
            {busy ? "Please wait…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
